import * as files from './files'
import * as share from './share'
import * as users from './users'
import * as settings from './settings'
import search from './search'
import commands from './commands'
import news from './news'

export {
  files,
  share,
  users,
  settings,
  commands,
  search,
  news
}
